// extracted by mini-css-extract-plugin
export var button = "Code-module--button--DN_Rz";
export var bxTextTruncateEnd = "Code-module--bx--text-truncate--end--13bOz";
export var bxTextTruncateFront = "Code-module--bx--text-truncate--front--1VYIZ";
export var container = "Code-module--container--3snfz";
export var copyButton = "Code-module--copy-button--26YxS";
export var dark = "Code-module--dark--1F552";
export var highlight = "Code-module--highlight--2X1Ku";
export var path = "Code-module--path--1-G0e";
export var pathRow = "Code-module--path-row--1u2gC";
export var row = "Code-module--row--126Jg";
export var showMoreButton = "Code-module--show-more-button--10nq0";
export var sideBarMinHeight = "Code-module--sideBarMinHeight--1JGz0";
export var sidebar = "Code-module--sidebar--2wnkY";